import { FormBase } from 'core/components';

export default class MissingDocumentEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'MISSING_DOCUMENT.EDIT.NAME_LABEL',
                    placeholder: 'MISSING_DOCUMENT.EDIT.NAME_PLACEHOLDER',
                    rules: ['string', 'max:100', 'required'],
                },
                {
                    name: 'itemCategoryId',
                    label: 'MISSING_DOCUMENT.EDIT.ITEM_CATEGORY_LABEL',
                    placeholder: 'MISSING_DOCUMENT.EDIT.ITEM_CATEGORY_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'note',
                    label: 'MISSING_DOCUMENT.EDIT.NOTE_LABEL',
                    placeholder: 'MISSING_DOCUMENT.EDIT.NOTE_PLACEHOLDER',
                    rules: 'string'
                },
            ],
        };
    }
}
